import Vue from "vue"
import App from "./App.vue"
// import "./registerServiceWorker"
import router from "./router.js"
import store from "./store.js"
import vuetify from "./plugins/vuetify"

import * as Sentry from "@sentry/browser"
import * as Integrations from "@sentry/integrations"

Sentry.init({
  dsn: "https://0a6823610d574301bed4918ab0e6cda5@sentry.io/4918932",
  integrations: [
    new Integrations.Vue({ Vue, attachProps: true, logErrors: true }),
  ],
})

const io = require("socket.io-client")

Vue.socket = Vue.prototype.socket =
  process.env.NODE_ENV === "development"
    ? io(`http://${location.hostname}:3515`)
    : io("https://colo.vaaski.com", { path: "/termin" })

Vue.dev = Vue.prototype.dev = process.env.NODE_ENV === "development"

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app")
